import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";

export type BarcodePdfOptions = {
  title?: string;
  columns?: number;
  barcodeWidthMm?: number;
  barcodeHeightMm?: number;
  marginMm?: number;
  gapMm?: number;
  fontSize?: number;
};

function createCode128DataUrl(value: string): string {
  const canvas = document.createElement("canvas");

  JsBarcode(canvas, value, {
    format: "CODE128",
    displayValue: false,
    margin: 0,
  });

  return canvas.toDataURL("image/png");
}

export async function exportIdsToBarcodePdf(
  ids: string[],
  barcodeDescription: string[],
  fileName = "barcodes.pdf",
  opts: BarcodePdfOptions = {}
) {
  const {
    title = "Skladové položky",
    columns = 3,
    barcodeWidthMm = 40,
    barcodeHeightMm = 15,
    marginMm = 10,
    gapMm = 10,
    fontSize = 10,
  } = opts;

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  // Title
  doc.setFontSize(14);
  doc.text(title, marginMm, marginMm);
  let cursorY = marginMm + 8;

  const cellW = barcodeWidthMm;
  const cellH = barcodeHeightMm + 8;

  const usableW = pageW - 2 * marginMm;
  const maxCols = Math.max(
    1,
    Math.min(columns, Math.floor((usableW + gapMm) / (cellW + gapMm)))
  );
  const cols = maxCols;

  let col = 0;
  let x = marginMm;
  let y = cursorY;
  let index= 0;

  for (const id of ids) {
    if (y + cellH > pageH - marginMm) {
      doc.addPage();
      doc.setFontSize(14);
      doc.text(title, marginMm, marginMm);
      y = marginMm + 8;
      x = marginMm;
      col = 0;
    }

    const dataUrl = createCode128DataUrl(id);

    doc.addImage(dataUrl, "PNG", x, y, barcodeWidthMm, barcodeHeightMm);

    doc.setFontSize(fontSize);
    doc.text(barcodeDescription[index], /*x + barcodeWidthMm / 2*/x, y + barcodeHeightMm + 6, {
      maxWidth: barcodeWidthMm,
      align: "left",
    });

    col += 1;
    if (col >= cols) {
      col = 0;
      x = marginMm;
      y += cellH + gapMm;
    } else {
      x += cellW + gapMm;
    }

    index++;
  }

  doc.save(fileName);
}